module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAQAAAAnOwc2AAAAVklEQVQI12NgAAKRFSK+DOhA0Fr0lUgEhrCIkegL0WQMYWFNkcciBRjC/Eqi90Tq0ARFVUQeipSiCAlpiTwRzUEREtAXfY5mkbAp0EnR6KYtEApG5gMAi6gP7G2Vd/AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/my/right.png
// module id = fOe4
// module chunks = 1